import styled from "styled-components";
import {
  DARK_GRAY,
  DARKER_GRAY,
  EARTH_GREEN,
  ERROR_RED,
  LIGHT_GRAY,
  RUBIK,
  WHITE,
} from "../../index.style.ts";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 30px 0;
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${RUBIK};
`;

export const Intro = styled.p`
  margin: 0;
  color: ${DARK_GRAY};
  line-height: 1.5;
`;

export const CardGrid = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const CardWrapper = styled.div`
  display: flex;
  gap: 16px;

  @media only screen and (max-width: 800px) {
    flex-direction: column;
  }
`;

export const Card = styled.div`
  background: ${WHITE};
  border: 1px solid ${LIGHT_GRAY};
  border-radius: 12px;
  padding: 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media only screen and (max-width: 800px) {
    width: 90%;
  }

  &.wide {
    width: stretch;

    @media only screen and (max-width: 800px) {
      width: 90%;
    }
  }

  h3 {
    margin: 0;
    font-family: ${RUBIK};
    font-size: 15px;
    color: ${DARK_GRAY};
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .big {
    font-size: 30px;
    font-family: ${RUBIK};
    color: ${DARKER_GRAY};
  }

  .sub {
    font-size: 13px;
    color: ${DARK_GRAY};
  }

  &.good .big {
    color: ${EARTH_GREEN};
  }

  &.warn .big {
    color: ${ERROR_RED};
  }
`;

export const EditRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 13px;
    color: ${DARK_GRAY};
  }

  input {
    font-family: inherit;
    font-size: 18px;
    padding: 8px 10px;
    border: 1px solid ${LIGHT_GRAY};
    border-radius: 8px;
    width: fit-content;
  }
`;

export const CoverageBar = styled.div`
  position: relative;
  height: 14px;
  border-radius: 7px;
  background: ${LIGHT_GRAY};
  overflow: hidden;

  span {
    position: absolute;
    inset: 0 auto 0 0;
    background: ${EARTH_GREEN};

    &.short {
      background: ${ERROR_RED};
    }
  }
`;

export const Recommendation = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  align-items: baseline;

  .label {
    font-size: 13px;
    color: ${DARK_GRAY};
  }

  .value {
    font-size: 22px;
    font-family: ${RUBIK};
    color: ${DARKER_GRAY};
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const EmptyState = styled.div`
  background: ${WHITE};
  border: 1px dashed ${LIGHT_GRAY};
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  p {
    margin: 0;
    color: ${DARK_GRAY};
  }
`;
